import { Box, BoxProps } from "./Box"
import { pulseClassName } from "./pulse.css"
import classNames from "classnames"

export function Pulse({ className, ...props }: BoxProps) {
	return <Box {...props} className={classNames(className, pulseClassName)} />
}
